import { appStorage } from './betaStorage'

export const familyHomeTiles = [
  { id: 'greeting', label: 'Good morning', to: '/youth-workspace' },
  { id: 'dinner', label: 'What’s for dinner?', to: '/care-menu' },
  { id: 'today', label: 'What’s happening today', to: '/youth-workspace/calendar' },
  { id: 'updates', label: 'Latest from the team', to: '/youth-workspace/messages' },
  { id: 'parent', label: 'Parent controls', to: '/youth-support-plan' },
  { id: 'snapshot', label: 'NIXI snapshot', to: '/youth-workspace/reports' },
  { id: 'quick', label: 'Quick access', to: '/youth-workspace/more-admin' },
  { id: 'tasks', label: 'Tasks & daily living', to: '/youth-workspace/tasks' },
  { id: 'child', label: 'Child view', to: '/youth-workspace' },
] as const

export type FamilyHomeTileId = typeof familyHomeTiles[number]['id']
export type FamilyHomePrefs = { order: FamilyHomeTileId[]; visible: FamilyHomeTileId[] }
const key = (userId: string) => `marnixia.familyHome.v1.${userId}`
const ids = familyHomeTiles.map(tile => tile.id)
const isId = (value: unknown): value is FamilyHomeTileId => typeof value === 'string' && ids.includes(value as FamilyHomeTileId)

export function loadFamilyHomePrefs(userId: string): FamilyHomePrefs {
  try {
    const saved = JSON.parse(appStorage.getItem(key(userId)) || 'null')
    if (!saved || !Array.isArray(saved.order) || !Array.isArray(saved.visible)) throw new Error('No preferences')
    // Replace the retired calendar tile with the short daily summary.
    const migrate = (values: unknown[]) => values.map(id => id === 'calendar' ? 'today' : id).filter(isId)
    const visible = [...new Set(migrate(saved.visible))]
    return {
      order: [...new Set([...migrate(saved.order), ...ids])],
      visible,
    }
  } catch {
    return { order: [...ids], visible: [...ids] }
  }
}

export function saveFamilyHomePrefs(userId: string, prefs: FamilyHomePrefs) {
  appStorage.setItem(key(userId), JSON.stringify(prefs))
  window.dispatchEvent(new Event('marnixia-family-home-updated'))
}
